import React, { useEffect, useState } from 'react';

import { useActions } from '../../../../hooks/useActions';
import { useAuth } from '../../../../hooks/useAuth';
import { useNavigate } from '../../../../hooks/useNavigate';
import { authorizeBankForAIOnboarding } from '../../../../quiltt';
import { Card } from '../../../common/Card';

import OnboardingAILinkAccounts from './OnboardingAILinkAccounts';

type OnboardingAIEmpoweredProps = {
  onClose: () => void;
};

const OnboardingAIEmpowered: React.FC<OnboardingAIEmpoweredProps> = () => {
  const { billingStatus } = useAuth();
  const navigate = useNavigate();
  const actions = useActions();

  const [viewState, setViewState] = useState<'intro' | 'select-accounts'>(
    'intro',
  );
  const [accountsData, setAccountsData] = useState([]);

  useEffect(() => {
    if (!billingStatus.isActive) {
      navigate('/');
    }
  }, [billingStatus.isActive]);
  useEffect(() => {
    linkAccountsHandler();
  }, []);

  const onAuthorizeBankSuccess = data => {
    const institutionData = [
      {
        institutionName: data.institution.name,
        isInstitution: true,
      },
      ...data.accounts.map(acc => ({
        ...acc,
        connectionId: data.connection_id,
        id: acc.account_id,
      })),
    ];
    const _accountsData = [...accountsData, ...institutionData];
    actions.closeModal();
    setAccountsData(_accountsData);
    setViewState('select-accounts');
  };

  const onAuthorizeBankClose = () => {
    if (accountsData.length > 0) {
      setViewState('select-accounts');
    } else {
      navigate('/onboarding');
    }
  };

  const linkAccountsHandler = () => {
    if (billingStatus.isActive) {
      authorizeBankForAIOnboarding(
        actions.pushModal,
        onAuthorizeBankSuccess,
        onAuthorizeBankClose,
      );
    }
  };

  return (
    <Card
      style={{
        padding: 20,
        textAlign: 'center',
        maxWidth: 856,
      }}
    >
      {viewState === 'select-accounts' && (
        <OnboardingAILinkAccounts
          accountsData={accountsData}
          onAddAccount={linkAccountsHandler}
        />
      )}
    </Card>
  );
};
export default OnboardingAIEmpowered;
